module.exports = __webpack_public_path__ + "img/parteight_pic3.cb2e0798.png";